(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(["exports", "babel-runtime/helpers/taggedTemplateLiteral", "react", "styled-components", "../../utils/propStyles"], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-runtime/helpers/taggedTemplateLiteral"), require("react"), require("styled-components"), require("../../utils/propStyles"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.taggedTemplateLiteral, global.react, global.styledComponents, global.propStyles);
        global.Spinner = mod.exports;
    }
})(this, function (exports, _taggedTemplateLiteral2, _react, _styledComponents, _propStyles) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.Spinner = undefined;

    var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

    var _react2 = _interopRequireDefault(_react);

    var _styledComponents2 = _interopRequireDefault(_styledComponents);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n    @keyframes rotator {\n        0% {\n            transform: rotate(0deg);\n        }\n        100% {\n            transform: rotate(360deg);\n        }\n    };\n\n    @keyframes dash {\n        0% {\n            stroke-dashoffset: ", ";\n        }\n        50% {\n            stroke-dashoffset: ", ";\n            transform: rotate(135deg);\n        }\n        100% {\n            stroke-dashoffset: ", ";\n            transform: rotate(360deg);\n        }\n    };\n\n    ", ";\n\n    animation: rotator ", " linear infinite;\n\n    circle {\n        stroke: currentcolor;\n        stroke-dasharray: ", ";\n        stroke-dashoffset: -36;\n        transform-origin: center;\n        animation: dash ", " ease-in-out infinite;\n    }\n"], ["\n    @keyframes rotator {\n        0% {\n            transform: rotate(0deg);\n        }\n        100% {\n            transform: rotate(360deg);\n        }\n    };\n\n    @keyframes dash {\n        0% {\n            stroke-dashoffset: ", ";\n        }\n        50% {\n            stroke-dashoffset: ", ";\n            transform: rotate(135deg);\n        }\n        100% {\n            stroke-dashoffset: ", ";\n            transform: rotate(360deg);\n        }\n    };\n\n    ", ";\n\n    animation: rotator ", " linear infinite;\n\n    circle {\n        stroke: currentcolor;\n        stroke-dasharray: ", ";\n        stroke-dashoffset: -36;\n        transform-origin: center;\n        animation: dash ", " ease-in-out infinite;\n    }\n"]);

    var offset = 124;
    var duration = '1s';

    // TODO: Investigate/fix bug 
    // - Use of keyframes here breaks other styles. 
    // - Seems as though it prevents style sheet injection further up in an app. However it works in one app and not in another...
    // - Keyframes used elsewhere without issue.
    // - Unable to find related issues raised in styled-components repo.
    // - Likely related to use of npm link and multiple instances of styled-components.
    // - As a workaround I have defined @keyframes within the styled-component, which seems to work ok.
    // Credit to original implementation https://codepen.io/mrrocks/pen/EiplA

    // const rotator = keyframes`
    //     0% {
    //         transform: rotate(0deg);
    //     }
    //     100% {
    //         transform: rotate(270deg);
    //     }
    // `;

    // const dash = keyframes`
    //     0% {
    //         stroke-dashoffset: ${offset};
    //     }
    //     50% {
    //         stroke-dashoffset: ${offset/4};
    //         transform: rotate(135deg);
    //     }
    //     100% {
    //         stroke-dashoffset: ${offset};
    //         transform: rotate(450deg);
    //     }
    // `;

    var SpinnerSvg = function SpinnerSvg(_ref) {
        var className = _ref.className;
        return _react2.default.createElement(
            "svg",
            {
                className: className,
                viewBox: "0 0 48 48",
                xmlns: "http://www.w3.org/2000/svg"
            },
            _react2.default.createElement("circle", {
                fill: "none",
                stroke: "currentcolor",
                strokeWidth: "8",
                strokeLinecap: "round",
                cx: "24",
                cy: "24",
                r: "20"
            })
        );
    };

    var Spinner = exports.Spinner = (0, _styledComponents2.default)(SpinnerSvg)(_templateObject, offset, offset / 4, offset, _propStyles.propStyles, duration, offset, duration);

    Spinner.defaultProps = {
        color: "inherit",
        iconSize: "24px"
    };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-portal-components/build/components/UI/Spinner.js
// module id = 165
// module chunks = 1